/**!
 * Created by Leonardo Cheslacki on 09/12/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import StageController from './StageController';

import Big from 'big.js';

import config from '../../../../config';

const {default: {api}} = config;

import WithType from './../helpers/WithType';
import {HelpersForm} from "../helpers";
import Moment from "moment/moment";

let _this = {};

/**
 *
 */
class StageMarquee extends StageController {

    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main = {}) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {};

        this.$bitmap_gallery = null;
        this.$bitmap_qrcode = null;
        this.$bitmap_thubnail = null;

        _this = this;
    };

    $functions = {
        /**
         *
         */
        handle: function () {

        }
    };

    startMarquee = () => {
        let data_news = [
            {
                text: 'Mercado imobiliário paga o dobro do CDI para quem investe no projeto – não no imóvel.',
                uri: 'https://monamooca.interativo.app.br/public/images/news/josue-isai-ramos-figueroa-qvBYnMuNJ9A-unsplash.jpg'
            },
            {
                text: 'Investimento imobiliário: há luz no fim do túnel.',
                uri: 'https://monamooca.interativo.app.br/public/images/news/shutterstock_258100103.jpg'
            },
            {
                text: 'Por que ser corretor de imóveis atrai cada vez mais brasileiros?',
                uri: 'https://monamooca.interativo.app.br/public/images/news/shutterstock_349275089.jpg'
            },
            {
                text: 'Alta do aluguel residencial desacelera para 0,33% em setembro, diz FGV.',
                uri: 'https://monamooca.interativo.app.br/public/images/news/predios3.174301.jpg'
            },
            {
                text: 'O que levou à crise no mercado de casas de luxo em Londres.',
                uri: 'https://monamooca.interativo.app.br/public/images/news/416964157-red.jpg'
            },
            {
                text: 'A construtora de casas de luxo que vai se aventurar em data centers na Índia.',
                uri: 'https://monamooca.interativo.app.br/public/images/news/416066978-1-1.jpg'
            },
            {
                text: 'Aluguel residencial sobe 1,93% em agosto, após queda em julho, afirma FGV.',
                uri: 'https://monamooca.interativo.app.br/public/images/news/real-estate-6688945_640.jpg'
            },
            {
                text: 'Imóveis no Rio de Janeiro estão mais baratos em 2024, mostra o FipeZAP.',
                uri: 'https://monamooca.interativo.app.br/public/images/news/1024px-Leblon_rio.jpg'
            },
            {
                text: 'Bancos e fintechs apostam em financiamento com garantia em imóvel já alienado.',
                uri: 'https://monamooca.interativo.app.br/public/images/news/prediosemsp.jpg'
            },
            {
                text: 'Mercado imobiliário ainda dá sinais de aquecimento, apesar de preços elevados.',
                uri: 'https://monamooca.interativo.app.br/public/images/news/real-estate-6688945_1280.jpg'
            }
        ];

        let data_video = [
            {
                text: 'Vídeo 01. Vídeo 01. Vídeo 01. Vídeo 01. Vídeo 01. Vídeo 01. Vídeo 01. Vídeo 01.',
                uri: 'https://monamooca.interativo.app.br/public/media/vr-girl.mp4'
            },
            {
                text: 'Vídeo 02. Vídeo 02. Vídeo 02. Vídeo 02. Vídeo 02. Vídeo 02. Vídeo 02. Vídeo 02.',
                uri: 'https://monamooca.interativo.app.br/public/media/example.mp4'
            },
            {
                text: 'Vídeo 03. Vídeo 03. Vídeo 03. Vídeo 03. Vídeo 03. Vídeo 03. Vídeo 03. Vídeo 03.',
                uri: 'https://monamooca.interativo.app.br/public/media/vr-boy.mp4'
            },
            {
                text: 'Vídeo 04. Vídeo 04. Vídeo 04. Vídeo 04. Vídeo 04. Vídeo 04. Vídeo 04. Vídeo 04.',
                uri: 'https://monamooca.interativo.app.br/public/media/doctor.mp4'
            }
        ];

        let
            {occ_marquee, occ_o_clock, occ_news, occ_qr} = this.getFrame(),
            {properties: {width}} = this.getComposition('index').getLibrary();

        occ_marquee.y = occ_marquee.y + 10;
        occ_o_clock.y = occ_o_clock.y + 12;
        occ_o_clock.x = occ_o_clock.x + 10;

        this.getOClockMoment('get-o-clock-moment', (time) => {
            occ_o_clock.text = time;
        });

        let temp = {};

        const execute = () => {
            this.$bitmap_gallery && occ_news.occ_gallery.occ_effect.occ_image.removeChild(this.$bitmap_gallery);
            this.$bitmap_thubnail && occ_news.occ_gallery.occ_effect.occ_image.removeChild(this.$bitmap_thubnail);

            if (this.isVideo === false) {
                temp = this.randomArray(data_video);

                let {uri} = temp;

                this.isVideo = true;

                this.startVideo(uri, {
                    start: ({thumbnail}) => {
                        this.$bitmap_thubnail = thumbnail;
                        occ_news.occ_gallery.occ_effect.occ_image.x = 0;
                        occ_news.occ_gallery.occ_effect.occ_image.y = 0;
                        occ_news.occ_gallery.occ_effect.occ_image.addChild(this.$bitmap_thubnail);
                        occ_news.occ_gallery.gotoAndPlay('start');
                    },
                    end: () => {
                        occ_news.occ_gallery.gotoAndPlay('complete');
                    }
                });
            } else {
                temp = this.randomArray(data_news);

                let {uri} = temp;

                this.isVideo = false;
                this.$bitmap_gallery = (new createjs.Bitmap(uri));

                this.$bitmap_gallery.image.onload = () => {
                    let
                        _scale = 0.8,
                        scaleX = (this.$bitmap_gallery.scaleX * this.toFloat(_scale)),
                        scaleY = (this.$bitmap_gallery.scaleY * this.toFloat(_scale)),
                        boundsImg = this.$bitmap_gallery.getBounds(),
                        big_width = this.calcSize(1, scaleX, boundsImg.width, true),
                        big_height = this.calcSize(1, scaleY, boundsImg.height, true);

                    this.$bitmap_gallery.scaleX = scaleX;
                    this.$bitmap_gallery.scaleY = scaleY;

                    occ_news.occ_gallery.occ_effect.occ_image.x = this.bigToNumber((new Big(occ_news.occ_gallery.occ_effect.nominalBounds.width)).minus(big_width).div(this.$controller.big_2), false, 'up');
                    occ_news.occ_gallery.occ_effect.occ_image.y = this.bigToNumber((new Big(occ_news.occ_gallery.occ_effect.nominalBounds.height)).minus(big_height).div(this.$controller.big_2), false, 'up');
                    occ_news.occ_gallery.occ_effect.occ_image.addChild(this.$bitmap_gallery);
                    occ_news.occ_gallery.gotoAndPlay('start');
                };
            }
        };

        this.main.on('animate_layer_complete', () => {
            if (this.isVideo) {
                this.state.element.play();
            }

            let {text} = temp;

            occ_marquee.x = width + 175;
            occ_marquee.text = text;

            let bounds = occ_marquee.getBounds();

            const tween = createjs.Tween.get(occ_marquee, {loop: true, override: true});

            tween.to({x: -Math.round(bounds.width)}, bounds.width * 5).call((object) => {
                object.paused = true;
                !this.isVideo && occ_news.occ_gallery.gotoAndPlay('complete');
            });
        });

        this.main.on('animate_layer_end', execute);

        execute();
    };

    startVideo = (uri, objectResponse) => {
        let
            type_loadeddata = 'loadeddata',
            reference_loadeddata = 'loadeddata-video',
            type_ended = 'ended',
            reference_ended = 'ended-video';

        this.setState({...this.state, element: document.createElement('video')}, ({element}) => {
            this.removeListener(type_loadeddata, reference_loadeddata, () => {
                this.addListener(element, type_loadeddata, reference_loadeddata, this.$functionsAnimate.handleLoadedDataVideoAnimate, false, {
                    _this_class: this,
                    reference: reference_loadeddata,
                    width: 1920,
                    height: 1080,
                    callback: (this.inFunction(objectResponse, 'start') ? objectResponse.start : this._void)
                });
            });

            this.removeListener(type_ended, reference_ended, () => {
                this.addListener(element, type_ended, reference_ended, (this.inFunction(objectResponse, 'end') ? objectResponse.end : this._void));
            });

            element.src = uri;
            element.currentTime = 1;
        });
    };

    startImage = () => {
        let qr_uri = 'https://monamooca.interativo.app.br/public/images/qr_test.jpg';

        let {occ_qr, occ_news: {occ_gallery: {occ_weather, occ_location}}} = this.getFrame();

        this.$bitmap_qrcode && occ_qr.occ_image.removeChild(this.$bitmap_qrcode);

        this.$bitmap_qrcode = (new createjs.Bitmap(qr_uri));

        this.$bitmap_qrcode.image.onload = () => {
            let
                _scale = 0.6,
                scaleX = (this.$bitmap_qrcode.scaleX * this.toFloat(_scale)),
                scaleY = (this.$bitmap_qrcode.scaleY * this.toFloat(_scale)),
                boundsImg = this.$bitmap_qrcode.getBounds(),
                big_width = this.calcSize(1, scaleX, boundsImg.width, true),
                big_height = this.calcSize(1, scaleY, boundsImg.height, true);

            this.$bitmap_qrcode.scaleX = scaleX;
            this.$bitmap_qrcode.scaleY = scaleY;

            occ_qr.occ_image.x = this.bigToNumber((new Big(occ_qr.nominalBounds.width)).minus(big_width).div(this.$controller.big_2), false, 'up');
            occ_qr.occ_image.y = this.bigToNumber((new Big(occ_qr.nominalBounds.height)).minus(big_height).div(this.$controller.big_2), false, 'up');

            occ_qr.occ_image.x = occ_qr.occ_image.x - 60;
            occ_qr.occ_image.y = occ_qr.occ_image.y + 60;

            occ_qr.occ_image.addChild(this.$bitmap_qrcode);
        };

        occ_weather.occ_min.y = occ_weather.occ_min.y + 10;
        occ_weather.occ_max.y = occ_weather.occ_max.y + 10;
        occ_weather.occ_rain.y = occ_weather.occ_rain.y + 10;
        occ_weather.occ_humidity.y = occ_weather.occ_humidity.y + 10;
        occ_location.occ_city.y = occ_location.occ_city.y + 10;

        let data_weather = [
            {
                uri: 'https://www.cptec.inpe.br/api/forecast-input?city=Curitiba, PR'
            },
            {
                uri: 'https://www.cptec.inpe.br/api/forecast-input?city=São Paulo, SP'
            },
            {
                uri: 'https://www.cptec.inpe.br/api/forecast-input?city=Rio de Janeiro, RJ'
            }
        ];

        const weather = () => {

            let {uri} = this.randomArray(data_weather);

            $.get(uri, function (data) {
                occ_weather.occ_min.text = `${data.temperatura_min}ºC`;
                occ_weather.occ_max.text = `${data.temperatura_max}ºC`;
                occ_weather.occ_rain.text = `${data.probabilidade_chuva}%`;
                occ_weather.occ_humidity.text = `${data.umidade}%`;
                occ_location.occ_city.text = `${data.cidade}-${data.uf}`;
                console.log(data);
            });
        };

        setInterval(weather, 30000);

        weather();
    };

    /**
     *
     */
    initMarquee = () => {
        this.startMarquee();
        this.startImage();
    };
}

/**
 *
 * @type {{}}
 */
StageMarquee.propTypes = {};

/**
 *
 * @type {{}}
 */
StageMarquee.defaultProps = {};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(StageMarquee, {className: 'StageMarquee'});
